import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Card, Divider, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { vendorService } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";

const { Meta } = Card;

function ViewVendor() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [vendor, setVendor] = useState([]);

  const initialize = async () => {
    const { success, data } = await vendorService.viewVendor(id);
    if (success) {
      setVendor(data);
    }
  };

  useEffect(() => {
    changeDocumentTitle("View Vendor");
    initialize();
  }, []);

  return (
    <>
      <Row gutter={0} className='flex justify-center'>

        <Col flex="500px" >
          <Card
            style={{ padding: '10px' }}
          >
            <Meta
              title={vendor?.name?.toUpperCase()}
              style={{ textAlign: 'center' }}
            />
            <div style={{ marginTop: '10px', textAlign: 'center' }}>
              <p> {vendor.email}</p>
            </div>
            <Divider />
            <div className='profile-info'>
              <div className="profile-item"><strong>Phone:</strong> <span>{vendor.phone}</span></div>
              <div className="profile-item"><strong>Address:</strong> <span>{vendor?.address?.toUpperCase()}</span></div>
              <div className="profile-item"><strong>Town:</strong> <span>{vendor.town?.toUpperCase()}</span></div>
              <div className="profile-item"><strong>City:</strong> <span>{vendor.city?.toUpperCase()}</span></div>
              <div className="profile-item"><strong>Country:</strong> <span>{vendor.country?.toUpperCase()}</span></div>
              <div className="profile-item"><strong>Secondary Email :</strong><span>{vendor.secondary_email || <span className="text-gray-400">none</span>}</span></div>

            </div>
            <Divider />
            <div style={{ textAlign: "center" }}>
              <Button type="primary" style={{ marginRight: "10px" }} onClick={() => navigate(`/operations/vendor/form/${id}`)}>
                <EditOutlined style={{ fontSize: "20px", cursor: "pointer" }} />
              </Button>
              {/* <DeleteOutlined
                  style={{ fontSize: "20px", cursor: "pointer" }}
                /> */}
            </div>
          </Card>
        </Col>

        {/* <Col flex="1">
          <div style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: "#FFFFFF" }}>
            <Row gutter={12}>
              <Col span={12}>
                <h1 style={{ fontWeight: "bold" }}>Browse Vendors</h1>
              </Col>
            </Row>
            <Table style={{ marginTop: "10px" }} />
          </div>
        </Col> */}

      </Row>


    </>
  );
}

export default ViewVendor;
